import { Chip, ChipGroup, Flex, Grid, List, Text, Tooltip } from '@shared/components';

export interface ExamCoursesReadonlyFieldProps {
  courses?: string[];
  isAllSelected?: boolean;
}

export default function ExamCoursesReadonlyField(props: Readonly<ExamCoursesReadonlyFieldProps>) {
  const { courses = [], isAllSelected = false } = props;

  return (
    <Grid
      sx={{
        gridTemplateColumns: '240px 1fr',
        gap: (theme) => theme.spacing(6),
      }}
    >
      <Text variant='body1Semibold'>หลักสูตรทดสอบ</Text>
      <Flex sx={{ gap: (theme) => theme.spacing(2.5), flexDirection: 'column' }}>
        <Text variant='body2Semibold'>หลักสูตรที่เปิดสอบ</Text>
        {isAllSelected ? (
          <Tooltip
            title={
              <List sx={{ listStyleType: 'disc', pl: 2 }}>
                {courses.map((label) => (
                  <li key={label}>{label}</li>
                ))}
              </List>
            }
          >
            <Chip
              sx={{ maxWidth: 130, fontSize: (theme) => theme.typography.body2Semibold.fontSize }}
              size='medium'
              label={`เลือกทั้งหมด (${courses.length})`}
            />
          </Tooltip>
        ) : (
          <ChipGroup
            slotProps={{
              wrapper: {
                sx: {
                  alignItems: 'center',
                },
              },
              elementsWrapper: {
                sx: {
                  gap: (theme) => theme.spacing(2),
                },
              },
              chip: {
                size: 'medium',
                sx: {
                  fontSize: (theme) => theme.typography.body2Semibold.fontSize,
                },
              },
            }}
            component='chip'
            labels={courses}
            limit={2}
            direction='row'
          />
        )}
      </Flex>
    </Grid>
  );
}
